import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import Header from './Header.vue';
import Sidebar from './sidebar.vue';
import Account_tabs from './account-tabs.vue';
import Index from './index.vue';
import Archived from './archived.vue';
import Api_qr_codes from './api-qr-codes.vue';
import Saved_designs from './saved-designs.vue';
import Add_save_design from './add-saved-design.vue';
import Edit_save_design from './edit-saved-design.vue';
import Generator from './generator.vue';
import Account from './account.vue';
import Api from './api.vue';
import Google_analytics from './google-analytics.vue';
import Team_members from './team-members.vue';
import Billing from './billing.vue';
import Cancel_reasons from './cancel-reasons.vue';
import Edit_billing from './edit-billing.vue';
import General_stats from './general-stats.vue';
import Stats from './stats.vue';
import Example_stats from './example-stats.vue';
import Feedback from './feedback.vue';
import Folders from './folders.vue';
import VueHeadful from 'vue-headful';
import VueCookies from 'vue-cookies';
import VueApexCharts from 'vue-apexcharts';

Vue.config.devtools = true;
Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(VueApexCharts);

const routes = [
  { name: 'index' ,path: '/dashboard/', component: Index },
  { name: 'index' ,path: '/dashboard/active', component: Index },
  { name: 'archived' ,path: '/dashboard/archived', component: Archived },
  { name: 'api-qr-codes' ,path: '/dashboard/api-qr-codes', component: Api_qr_codes },
  { name: 'saved-designs' ,path: '/dashboard/saved-designs', component: Saved_designs },
  { name: 'add-saved-design' ,path: '/dashboard/add-saved-design', component: Add_save_design },
  { name: 'edit-saved-design' ,path: '/dashboard/edit-saved-design/:designid', component: Edit_save_design },
  { name: 'generator', path: '/dashboard/generator/:qrid?', component: Generator }, // Single route with optional parameter
  { name: 'account' ,path: '/dashboard/account', component: Account },
  { name: 'api' ,path: '/dashboard/api', component: Api },
  { name: 'google-analytics' ,path: '/dashboard/google-analytics', component: Google_analytics },
  { name: 'team-members' ,path: '/dashboard/team-members', component: Team_members },
  { name: 'billing' ,path: '/dashboard/billing', component: Billing },
  { name: 'cancel-reasons' ,path: '/dashboard/cancel-reasons', component: Cancel_reasons },
  { name: 'edit-billing' ,path: '/dashboard/edit-billing', component: Edit_billing },
  { name: 'general-stats' ,path: '/dashboard/general-stats', component: General_stats },
  { name: 'stats' ,path: '/dashboard/stats/:qrid', component: Stats },
  { name: 'example-stats' ,path: '/dashboard/example-stats', component: Example_stats },
  { name: 'feedback' ,path: '/dashboard/feedback/:qrid', component: Feedback },
  { name: 'folders' ,path: '/dashboard/folder/:folderid', component: Folders },
];

const router = new VueRouter({
  scrollBehavior() {
  return { x: 0, y: 0 };
},
routes,
mode: 'history'
});

Vue.component('app-header', Header);
Vue.component('sidebar-header', Sidebar);
Vue.component('account-header', Account_tabs);
Vue.component('vue-headful', VueHeadful);
Vue.component('apexchart', VueApexCharts);

var vm  = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
window.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js